<template>
  <div class="flex-shrink-0 px-4 pt-4 sm:px-6 sm:pt-5">
    <div class="flex items-center justify-between">
      <DialogTitle
        as="h3"
        class="text-lg font-medium leading-6 text-gray-900 dark:text-gray-100"
      >
        {{ isEditMode ? t('app.views.orders.modals.new_order.title_edit_order', {
          id: orderNumber
        }) : t('app.views.orders.modals.new_order.title') }}
      </DialogTitle>
      <button
        type="button"
        class="rounded-md bg-white dark:bg-transparent text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        @click="emit('close')"
      >
        <span class="sr-only">{{ t('app.views.orders.modals.new_order.close') }}</span>
        <XMarkIcon
          class="h-6 w-6"
          aria-hidden="true"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DialogTitle } from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useI18n } from 'vue-i18n'

interface Props {
  isEditMode: boolean
  orderNumber?: string | number
}

defineProps<Props>()

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()
</script>
